import React, { useState } from 'react';
import SEOHead from '../components/SEOHead';
import LightboxModal from '../components/LightboxModal';
import { TEAM_MEMBERS } from '../data/scrapeData';

export default function AboutPage() {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  const openLightbox = (index) => {
    setLightboxIndex(index);
    setLightboxOpen(true);
  };

  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Om os – Vognmand & Entreprenør DBM aps"
        description="Velkommen hos Vognmand & Entreprenør DBM aps. Vi har beliggenhed ved Hjorthede nær Bjerringbro."
      />

      {/* Header Banner */}
      <section
        className="relative bg-cover bg-center bg-no-repeat text-white py-20 sm:py-32 px-4 sm:px-8 border-b-4 border-neutral-800 text-center flex items-center justify-center min-h-[350px] sm:min-h-[440px]"
        style={{
          backgroundImage:
            'url("https://assets.auxodev.dk/cdn-cgi/image/width=1920,quality=80,format=auto/assets/97798019-8392-40d4-89ba-059b36d499c2/2026-03-03-09-57-45.jpg")',
        }}
      >
        <div className="relative z-10 max-w-4xl mx-auto drop-shadow-lg [text-shadow:_0_2px_10px_rgba(0,0,0,0.8)]">
          <h1 className="text-3xl sm:text-5xl md:text-6xl font-black tracking-tight text-white">
            Om os
          </h1>
          <div className="mt-6">
            <a
              href="/kontakt/"
              className="inline-block bg-black hover:bg-neutral-800 text-white font-bold px-8 py-3.5 rounded text-sm uppercase tracking-wider border border-white/30 transition-colors shadow-lg"
            >
              Kontakt os her
            </a>
          </div>
        </div>
      </section>

      {/* Main Text Section */}
      <section className="py-12 px-4 sm:px-8 max-w-7xl mx-auto">
        <div className="space-y-6 text-gray-800 leading-relaxed text-base">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">
            Velkommen hos Vognmand & Entreprenør DBM aps
          </h2>
          <p className="font-semibold text-lg text-gray-900">
            Vi har beliggenhed ved Hjorthede nær Bjerringbro.
          </p>
          <p>
            Vognmand & Entreprenør forretningen er stiftet af Nick Mann Hedegaard Laursen, som har stor erfaring inden for begge områder.
          </p>
          <p>
            Hos Vognmand & Entreprenør DBM Aps finder du dygtige og erfaren mandskab, som har en bred vifte af kompetencer inden for netop dette område.
          </p>
          <p>
            Vi bestræber os altid på at fuldføre opgaven til tiden, og så præcis som muligt, så vores kunder får indfriet deres forventninger. Vi er i dag 6 ansatte samt Nick selv, vi har pt 6 lastbiler som vi udfører alle daglige opgaver med, vi kører hovedsaglig i Jylland, men skulle det være til hjælp tager vi gerne en tur til øerne også.
          </p>

          <div className="pt-4 border-t border-gray-100">
            <ul className="space-y-2 font-semibold text-gray-900">
              <li className="flex items-center space-x-2">
                <i className="fa-solid fa-check text-neutral-800"></i>
                <span>Vi klarer de fleste opgaver – både store og små.</span>
              </li>
              <li className="flex items-center space-x-2">
                <i className="fa-solid fa-check text-neutral-800"></i>
                <span>Vi leverer materialer både til private og firmaer.</span>
              </li>
              <li className="flex items-center space-x-2">
                <i className="fa-solid fa-check text-neutral-800"></i>
                <span>Vi transporterer gods af alle typer (dog ikke dyr).</span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-12 bg-gray-50 border-t border-gray-200 px-4 sm:px-8">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-2xl sm:text-3xl font-black text-gray-900 text-center uppercase tracking-tight mb-10">
            Bag om Vognmand & Entreprenør DBM Aps
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {TEAM_MEMBERS.map((member, index) => (
              <div
                key={index}
                className="bg-white rounded shadow-md overflow-hidden border border-gray-200 text-center flex flex-col group cursor-pointer"
                onClick={() => openLightbox(index)}
              >
                <div className="relative aspect-square overflow-hidden bg-gray-100">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                    <span className="bg-black text-white text-xs font-bold px-3 py-1.5 rounded uppercase tracking-wider shadow-md">
                      Forstør
                    </span>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="text-base font-bold text-gray-900">{member.name}</h3>
                  <p className="text-xs font-semibold text-gray-600 uppercase tracking-wider mt-1">
                    {member.title}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox Modal */}
      <LightboxModal
        images={TEAM_MEMBERS.map(m => ({ src: m.image, title: `${m.name} - ${m.title}` }))}
        currentIndex={lightboxIndex}
        isOpen={lightboxOpen}
        onClose={() => setLightboxOpen(false)}
        onPrev={() => setLightboxIndex((prev) => (prev > 0 ? prev - 1 : TEAM_MEMBERS.length - 1))}
        onNext={() => setLightboxIndex((prev) => (prev < TEAM_MEMBERS.length - 1 ? prev + 1 : 0))}
      />
    </div>
  );
}
